// extracted by mini-css-extract-plugin
export default {"Link":"NavigateLink_Link__Jo3MV"};